import { useSearchParams } from 'react-router-dom'
import { useAuth } from './auth.jsx'
import { qs } from './api.js'

/**
 * A hatchery user is pinned to its own hatchery. An admin opens the same
 * screens for any hatchery by carrying ?hatcheryId=… through the URL — that is
 * how the admin desk fixes a listing for a hatchery that phoned it in.
 */
export function useHatcheryScope () {
  const { user } = useAuth()
  const [params] = useSearchParams()
  const asAdmin = user?.role === 'admin'
  const hatcheryId = asAdmin ? params.get('hatcheryId') : null

  return {
    asAdmin,
    hatcheryId,
    /** Append to an API path: `/hatchery/summary${scope.query}` */
    query: hatcheryId ? qs({ hatcheryId }) : '',
    /** Append to an in-app link so the admin stays in the same hatchery. */
    link: hatcheryId ? `?hatcheryId=${hatcheryId}` : '',
    /** Merge into a POST/PATCH body. */
    body: hatcheryId ? { hatcheryId } : {},
    missing: asAdmin && !hatcheryId
  }
}
